import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { HeaderProvider } from './contexts/HeaderContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Assessments from './pages/Assessments';
import AssessmentDetail from './pages/AssessmentDetail';
import SimpleQuestionnaire from './pages/SimpleQuestionnaire';
import MaturityDashboard from './pages/MaturityDashboard';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import QuestionnaireEditor from './pages/QuestionnaireEditor';
import Users from './pages/Users';
import EmailTesting from './pages/EmailTesting';
import Register from './pages/Register';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <SocketProvider>
          <LayoutProvider>
            <HeaderProvider>
              <div className="App">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route
                    path="/internal"
                    element={<Navigate to="/login?workspace_login=true" replace />}
                  />
                  <Route
                    path="/*"
                    element={
                      <ProtectedRoute>
                        <Layout>
                          <Routes>
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/clients" element={<Clients />} />
                            <Route path="/clients/:id" element={<ClientDetail />} />
                            <Route path="/clients/:clientId/settings" element={<Settings />} />
                            <Route path="/assessments" element={<Assessments />} />
                            <Route path="/assessments/:id" element={<AssessmentDetail />} />
                            <Route path="/assessments/:id/questionnaire" element={<SimpleQuestionnaire />} />
                            <Route path="/assessments/:id/maturity" element={<MaturityDashboard />} />
                            <Route path="/reports" element={<Reports />} />
                            <Route path="/questionnaires" element={<QuestionnaireEditor />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/email-testing" element={<EmailTesting />} />
                          </Routes>
                        </Layout>
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </div>
            </HeaderProvider>
          </LayoutProvider>
        </SocketProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
